var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"justify-center d-flex flex-column",attrs:{"cols":"12","md":"4"}},[_c('v-img',{staticClass:"ma-5",attrs:{"aspect-ratio":"1","src":require('@/assets/images/moodboard/' + _vm.source + '.webp')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }